import { atom, RecoilState } from 'recoil';
import {
	VehicleDetails,
	FeaturesAndCapabilitiesResponsePayloadService
} from '../../@types/dataTypes';

export type featuresAndCapabilitiesAtom = RecoilState<
	FeaturesAndCapabilitiesResponsePayloadService[] | []
>;
export type VehicleDetailsAtom = RecoilState<VehicleDetails | {}>;

export const vehicleDetailsAtom: VehicleDetailsAtom = atom({
	key: `vehicleDetailsAtom`,
	default: {}
});

export const featuresAndCapabilitiesAtom: featuresAndCapabilitiesAtom = atom<
	FeaturesAndCapabilitiesResponsePayloadService[] | []
>({
	key: `featuresAndCapabilitiesAtom`,
	default: []
});

export const ctpeuResponseStatusCodeAtom = atom<string>({
	key: `ctpeuResponseStatusCodeAtom`,
	default: ``
});

export const vehicleDataLoaderAtom = atom<boolean>({
	key: `vehicleDataLoaderAtom`,
	default: false
});
